<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 dan-connect h-100">
                    <div class="bg-white border-radius-5 p-5 h-100">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center pt-3">
                                    <div class="col-md-6 text-center">
                                        <h2>DNA Connect</h2>
                                        <p>Connecting your DNA gives you detailed insights form your DNA for free! This includes 30+ DNA Reports, adjusted nutrition values to your genetic needs, and an optimized vitamin plan!</p>
                                        <router-link class="btn btn-blue dna-Connect" to="/connect-dna">Connect my DNA</router-link>
                                        <div class="Gini-dna-Kit px-4 py-5 mt-4 bg-body border-radius-10">
                                            <h3>Not DNA tested? Get Gini’s DNA Kit</h3>
                                            <p>Gini Provides a comprehensive DNA kit and reports without the need of geeting tasted with a third party!</p>
                                            <a class="btn btn-blue dna-gini-button" href="#">Get Gini DNA kit</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "dna-connect",
        data() {
            return {};
        },
        created(){
           this.pageName('DNA Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/dna/dna-connect.vue